import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useTranslate } from 'react-admin';
export default function ConfirmDialog({ open, handleClose, handleConfirm, ContentText, Tittle }) {
  const translate = useTranslate();
  return (
    <div>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title"> {Tittle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{textAlign:'center'}}>
            {ContentText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            {translate(`pos.user.cancel`)}
          </Button>
          <Button onClick={handleConfirm} color="primary" autoFocus>
            {translate(`pos.user.ok`)}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
